<ng-container *ngIf="data">

  <a *ngIf="data.type === urlType.External"
     [ngClass]="!styleAsText ? 'base-button ' + buttonClass : 'text-link'"
     href="{{ data.url }}"
     target="{{ data.target }}"
     #linkEl>
    <div *ngIf="styleAsText"
         class="base-button__left">
      <div class="base-button__left--arrow"></div>
    </div>
    <span class="base-button__link" [innerHTML]='data.name'></span>
  </a>

  <a *ngIf="data.type === urlType.Node"
     [ngClass]="!styleAsText ? 'base-button ' + buttonClass : 'text-link'"
     [routerLink]="[data.url]"
     #linkEl>
    <div *ngIf="styleAsText"
         class="base-button__left">
      <div class="base-button__left--arrow"></div>
    </div>
    <span class="base-button__link" [innerHTML]='data.name'></span>
  </a>

  <a *ngIf="data.type === urlType.Media"
     [ngClass]="!styleAsText ? 'base-button ' + buttonClass : 'text-link'"
     [href]="data.url"
     target="{{ data.target }}"
     #linkEl>
    <div *ngIf="styleAsText"
         class="base-button__left">
      <div class="base-button__left--arrow"></div>
    </div>
    <span class="base-button__link" [innerHTML]='data.name'></span>
  </a>
</ng-container>
